import { ERequestType } from "../../Enum/ERequestType"
import type { OrderPaginationOptions, OrderPaginationState } from "../../hooks/Order/useGetOrder"

const CASH_FLOW_ORDER_PAGE_SIZE = 90

type HandleGetOrder = (
  onSuccess: (() => void) | null,
  dateStart: string,
  dateEnd?: string | null,
  rote?: string,
  requestType?: ERequestType,
  onlyOpenLostOrders?: boolean,
  onlyOpenKitchenDelayed?: boolean,
  paginationOptions?: OrderPaginationOptions,
  suppressGlobalLoading?: boolean,
) => Promise<OrderPaginationState | null>

export const loadCashFlowOrders = async (handleGetOrder: HandleGetOrder, dateStart: string, dateEnd: string) => {
  let pageNumber = 1
  
  let hasNextPage = true

  while (hasNextPage) {
    const paginationState = await handleGetOrder(
      () => {},
      dateStart,
      dateEnd,
      undefined,
      undefined,
      false,
      false,
      {
        append: pageNumber > 1,
        pageNumber,
        pageSize: CASH_FLOW_ORDER_PAGE_SIZE,
      },
      true,
    )

    if (!paginationState) {
      throw new Error("Failed to load cash flow orders.")
    }

    if (!paginationState.hasNextPage) {
      hasNextPage = false
      continue
    }

    pageNumber = paginationState.pageNumber + 1
  }
}
